import { Tag as AntTag, Popover } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Typography } from '../Typography';
import useMobileView from '@design-system/hooks/useMobileView';

const StyledTag = styled(AntTag)`
  padding: 5px 11px;
  color: #000;
  background-color: ${({ theme }) => theme.color.background};
  border: 1px solid #000;
  border-radius: 5px;
  line-height: 7px;
  margin-right: 0;
`;

const StyledPopoverContent = styled.div`
  width: 310px;

  .container {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    position: relative;
    ${(props) => props.theme.typo.familyGoogle.regular};
    background-color: ${(props) => props.theme.color.gunPowder};
    color: ${(props) => props.theme.color.onPrimary};
    border-radius: 12px;
    padding: 30px;

    .title {
      font-size: 28px;
      line-height: 28px;
      color: ${(props) => props.theme.color.onPrimary};
    }

    .desc {
      margin-top: 24px;
      line-height: 140%;
      color: ${(props) => props.theme.color.onPrimary};
    }

    .content {
      margin-top: 24px;
      line-height: 140%;
      color: ${(props) => props.theme.color.onPrimary};
    }

    .primary {
      color: ${(props) => props.theme.color.primaryBase};
    }
  }
`;

const StyledTagWrapper = styled.div`
  width: fit-content;
`;

const AsIsTag = () => {
  const { t } = useTranslation();
  const isMobile = useMobileView(992);

  return (
    <Popover
      placement={'bottomLeft'}
      trigger={isMobile ? 'click' : 'hover'}
      overlayClassName="as-is-popover"
      content={
        <StyledPopoverContent>
          <div className="container">
            <div className="title">
              <Typography className="title" variant="header">
                <Trans i18nKey="shared.asIs.tag.popover.title" />
              </Typography>
            </div>
            <div className="desc">
              <Typography className="desc" variant="captionRegular">
                <Trans i18nKey="shared.asIs.tag.popover.desc" components={{ primary: <span className="primary" /> }} />
              </Typography>
            </div>
            <div className="content">
              <Typography className="content" variant="smallButtonOrLink">
                <Trans
                  i18nKey="shared.asIs.tag.popover.content"
                  components={{ primary: <span className="primary" /> }}
                />
              </Typography>
            </div>
          </div>
        </StyledPopoverContent>
      }
    >
      <StyledTagWrapper>
        <StyledTag>{t('shared.asIs.tag.label')}</StyledTag>
      </StyledTagWrapper>
    </Popover>
  );
};

export default AsIsTag;
